import { render, staticRenderFns } from "./MealBreakUpcoming.vue?vue&type=template&id=1494ecae&"
import script from "./MealBreakUpcoming.vue?vue&type=script&lang=js&"
export * from "./MealBreakUpcoming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports